export default "__VITE_ASSET__Rn8sIHMF__"